export default (minsToStart, minsToEnd) => {
  let hours, mins, elapsedMins;
  let minLabel = 'minutes';
  let hourLabel = 'hours';
  if(minsToEnd > minsToStart) elapsedMins = minsToEnd - minsToStart;
  else elapsedMins = 1440 - minsToStart + minsToEnd;
  hours = Math.floor(elapsedMins / 60);
    mins = elapsedMins % 60;
  if(mins === 1) minLabel = 'minute';
  if(hours === 1) hourLabel = 'hour';
  if(hours === 0 && mins !== 0) return `${mins} ${minLabel}`;
  else if(hours !== 0 && mins === 0) return `${hours} ${hourLabel}`;
  else if(hours !== 0 && mins !== 0) return `${hours} ${hourLabel} ${mins} ${minLabel}`;
}